const baseUrl = process.env.REACT_APP_ASSETS_URL || 'https://show.originqc.com.cn/prod/quantum_cloud/webAppAssetsFiles/';

export const  assetsUrl = baseUrl;
export const  assetsUrlFont = `${baseUrl}assets/fonts/`;
export const  assetsUrlImage = `${baseUrl}assets/images/`;
export const  assetsUrlPlugins = `${baseUrl}assets/plugins/`;

export const  assetsVideoUrl = `${baseUrl}../videos`; // 视频地址